// Run on page load
document.addEventListener('DOMContentLoaded', (e) => {
	cardVideo();
	soldOutVariant();
});

/**
 * Autoplays card-product vidoes on hover
 */
function cardVideo() {
	document.querySelectorAll('.card-wrapper').forEach(wrapper => {
		const video = wrapper.querySelector('video');
		if (video) {
			wrapper.addEventListener('mouseover', () => {
				if (video.readyState === 0) video.load();
				video.play();
			});
			wrapper.addEventListener('mouseout', () => {
				const video = wrapper.querySelector('video');
				video.pause();
			});
		}
	});
}

/**
 * SOLD OUT support for variations 
 */
function soldOutVariant() {
	document.addEventListener('change', function (e) {
		if (e.target.classList.contains('select__select')) {
			const option = e.target.options[e.target.selectedIndex];
			const status = option.dataset.status;
			const value = option.value;

			let btns = [];
			if (document.body.classList.contains('product')) {
				btns = document.querySelectorAll('.product-form .button');
			} else {
				const form = e.target.closest('form');
				btns = form.querySelectorAll('.button');

			}
			if (status === 'sold-out') {
				btns[0].classList.add('hidden');
				btns[1].classList.remove('hidden');
				btns[1].setAttribute('data-variant-id', value);
			} else if (status === 'available') {
				btns[0].classList.remove('hidden');
				btns[1].classList.add('hidden');
			}
		}
	})
}
